import { CollaboratorRegisterTemplate } from "../../Templates/CollaboratorRegisterTemplate";

export const CollaboratorRegister = () => {
  return <CollaboratorRegisterTemplate />;
};
